import {ApiClient} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'

/**
 * Plant-configuration-based feature flag system.
 * ⚠️ Deprecated approach – migration to ConfigCat (@hproduce/feature-flags) is planned.
 */

export enum PlannerFeature {
  Stock = 'stock_screen',
  PriceForecast = 'price_forecast_screen',
  DemandForecast = 'demand_forecast_screen',
  Planning = 'planning_screen',
  Optimizer = 'optimizer_screen',
  ElectricityPurchasing = 'electricity_purchasing',
  ControlOperatorScreen = 'control_room_operator_view',
  ThreeShippingTypes = 'three_shipping_types'
}

const usePlantConfigQuery = () => {
  const {plantId: plantCode} = useUpmPlantContext()
  return useQuery({
    queryKey: ['plantConfig', plantCode],
    queryFn: async () => {
      const response = await ApiClient.axiosInstance.get<{available_features: string[]}>(
        `/hcem/ui/v2/config/${plantCode}`
      )
      return response.data
    }
  })
}

/**
 * @deprecated Remove after planner features are exported to config cat
 */
export const usePlannerFeature = (feature: PlannerFeature): boolean => {
  const {data: plantConfig} = usePlantConfigQuery()
  const availableFeatures = plantConfig?.available_features ?? []
  return availableFeatures.includes(feature)
}
